import React, {useEffect, useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {useDispatch, useSelector} from "react-redux";
import {retrieveDeliveryYearAuctions, retrieveLdas} from "../../../store/capacity-exchange/actions/CapacityExchangeActions";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import {cleanStringInput} from "../../../Utility/StringUtil";
import InputAdornment from "@material-ui/core/InputAdornment";
import {trackPromise} from "react-promise-tracker";
import {onError, onSuccess} from "../../../store/actions/popupActions";
import RemoveIcon from "@material-ui/icons/Remove";
import Button from "@material-ui/core/Button";
import axios from "../../../axios/AxiosInterceptors";
import {useHistory} from "react-router-dom";
import TwoDigitCurrency from "../../NumberFormat/TwoDigitCurrency";

const useStyles = makeStyles((theme) => ({
    offset: theme.mixins.toolbar,
    layout: {
        width: 'auto',
        marginTop: theme.spacing(10),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
            width: 1200,
            marginLeft: 'auto',
            marginRight: 'auto',
        }
    },
    paper: {
        width: 'auto',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(5),
    },
    table: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    tableRow: {
        "&:hover": {
            cursor: 'pointer'
        }
    }
}));

const CreateResourceClearingPrices = (props) => {

    const classes = useStyles(props);
    const dispatch = useDispatch();
    const history = useHistory();
    const deliveryYearAuctions = useSelector(state => state.capacity.deliveryYearAuctions);
    const ldas = useSelector(state => state.capacity.ldas);
    const [auctionResourceClearingPrice, setAuctionResourceClearingPrice] = useState({deliveryYear: '', auction: '', systemMarginalPrice: '', resourceClearingPrices: []});

    useEffect(() => {
        if (!deliveryYearAuctions) {
            dispatch(retrieveDeliveryYearAuctions());
        }
        if (!ldas) {
            dispatch(retrieveLdas());
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderLdaSelectBox = (resourceClearingPrice, index) => {
        if (ldas && ldas.length > 0) {
            return (
                <Autocomplete value={resourceClearingPrice.ldaName} options={['', ...ldas.map(lda => lda.ldaName)]}
                              renderInput={(params) => <TextField {...params} label="LDA"/>}
                              onChange={(event, value) => onLdaSelectChange(event, value, index)}/>
            );
        }
    }

    const onLdaSelectChange = (event, value, index) => {
        auctionResourceClearingPrice.resourceClearingPrices[index].ldaName = value;
        setAuctionResourceClearingPrice({...auctionResourceClearingPrice});
    }

    const renderDeliveryYearSelectBox = () => {
        if (deliveryYearAuctions) {
            return (
                <Autocomplete value={auctionResourceClearingPrice.deliveryYear} options={['', ...Object.keys(deliveryYearAuctions).sort((c1, c2) => c2.localeCompare(c1))]}
                              getOptionLabel={(option) => option}
                              renderInput={(params) => <TextField {...params} label="Delivery Year"/>}
                              onChange={(event, value) => onDeliveryYearSelectChange(event, value)}/>
            );
        }
    }

    const renderAuctionSelectBox = () => {
        if (auctionResourceClearingPrice.deliveryYear) {
            return (
                <Autocomplete value={auctionResourceClearingPrice.auction}
                              options={['', ...deliveryYearAuctions[auctionResourceClearingPrice.deliveryYear].map(r => r.auction)]}
                              getOptionLabel={(option) => option} renderInput={(params) => <TextField {...params} label="Auction"/>}
                              onChange={(event, value) => onAuctionSelectChange(event, value)}/>
            );
        }
        return (
            <Autocomplete value={auctionResourceClearingPrice.auction} options={['']} getOptionLabel={() => ''}
                          renderInput={(params) => <TextField {...params} label="Auction"/>}/>
        );
    }

    const onDeliveryYearSelectChange = (event, value) => {
        if (value) {
            auctionResourceClearingPrice.deliveryYear = value;
        } else {
            auctionResourceClearingPrice.deliveryYear = '';
            auctionResourceClearingPrice.auction = '';
        }
        setAuctionResourceClearingPrice({...auctionResourceClearingPrice});
    }

    const onAuctionSelectChange = (event, value) => {
        if (value) {
            auctionResourceClearingPrice.auction = value;
        } else {
            auctionResourceClearingPrice.auction = '';
        }
        setAuctionResourceClearingPrice({...auctionResourceClearingPrice});
    }

    const addIconClick = () => {
        auctionResourceClearingPrice.resourceClearingPrices.push({ldaName: ""});
        setAuctionResourceClearingPrice({...auctionResourceClearingPrice});
    }

    const removeIconClick = (index) => {
        auctionResourceClearingPrice.resourceClearingPrices.splice(index, 1);
        setAuctionResourceClearingPrice({...auctionResourceClearingPrice});
    }

    const renderAddIcon = (totalCount, index) => {
        if (index === totalCount) {
            return (
                <IconButton onClick={addIconClick}>
                    <AddIcon/>
                </IconButton>
            )
        }
    }

    const renderResourceClearingPrices = () => {
        let renderedClearingPrices = [];
        if (!auctionResourceClearingPrice.resourceClearingPrices || auctionResourceClearingPrice.resourceClearingPrices.length === 0) {
            auctionResourceClearingPrice.resourceClearingPrices.push({ldaName: ''});
        }
        for (let i = 0; i < auctionResourceClearingPrice.resourceClearingPrices.length; i++) {
            renderedClearingPrices.push(renderResourceClearingPrice(auctionResourceClearingPrice.resourceClearingPrices[i],
                auctionResourceClearingPrice.resourceClearingPrices.length - 1, i));
        }
        return renderedClearingPrices;
    }

    const onInputChange = (e, index) => {
        if (e.target.value) {
            auctionResourceClearingPrice.resourceClearingPrices[index][e.target.name] = Number.parseFloat(e.target.value);
        } else {
            auctionResourceClearingPrice.resourceClearingPrices[index][e.target.name] = '';
        }
        setAuctionResourceClearingPrice({...auctionResourceClearingPrice});
    }

    const onSystemMarginalPriceChange = (e) => {
        if (e.target.value) {
            auctionResourceClearingPrice.systemMarginalPrice = Number.parseFloat(e.target.value);
        } else {
            auctionResourceClearingPrice.systemMarginalPrice = '';
        }
        setAuctionResourceClearingPrice({...auctionResourceClearingPrice});
    }

    const renderResourceClearingPrice = (resourceClearingPrice, totalCount, index) => {
        return (
            <Grid container spacing={2} key={index}>
                <Grid item xs={6} sm={2}/>
                <Grid item xs={6} sm={3}>
                    {renderLdaSelectBox(resourceClearingPrice, index)}
                </Grid>
                <Grid item xs={6} sm={1}/>
                <Grid item xs={6} sm={3}>
                    <TextField label="Locational Price Adder" name="locationalPriceAdder" value={cleanStringInput(resourceClearingPrice.locationalPriceAdder)}
                               onChange={(e) => onInputChange(e, index)} fullWidth type="number"
                               InputProps={{
                                   endAdornment: <InputAdornment position="start">$/MW-Day</InputAdornment>,
                                   inputComponent: TwoDigitCurrency,
                                   inputProps: {isEdit: true}
                               }}/>
                </Grid>
                <Grid item xs={6} sm={2}/>
                <Grid item xs={6} sm={2}/>
                <Grid item xs={6} sm={3}>
                    <TextField label="CP Resource Clearing Price" name="capacityPerformanceResourceClearingPrice"
                               value={cleanStringInput(resourceClearingPrice.capacityPerformanceResourceClearingPrice)}
                               onChange={(e) => onInputChange(e, index)} fullWidth type="number"
                               InputProps={{
                                   endAdornment: <InputAdornment position="start">$/MW-Day</InputAdornment>,
                                   inputComponent: TwoDigitCurrency,
                                   inputProps: {isEdit: true}
                               }}/>
                </Grid>
                <Grid item xs={6} sm={1}/>
                <Grid item xs={6} sm={3}>
                    <TextField label="Base Clearing Price" name="baseCapacityResourceClearingPrice"
                               value={cleanStringInput(resourceClearingPrice.baseCapacityResourceClearingPrice)}
                               onChange={(e) => onInputChange(e, index)} fullWidth type="number"
                               InputProps={{
                                   endAdornment: <InputAdornment position="start">$/MW-Day</InputAdornment>,
                                   inputComponent: TwoDigitCurrency,
                                   inputProps: {isEdit: true}
                               }}/>
                </Grid>
                <Grid item xs={6} sm={2}/>
                <Grid item xs={6} sm={2}/>
                <Grid item xs={6} sm={3}>
                    <TextField label="Base DR/EE Clearing Price" name="baseCapacityDrEeClearingPrice"
                               value={cleanStringInput(resourceClearingPrice.baseCapacityDrEeClearingPrice)}
                               onChange={(e) => onInputChange(e, index)} fullWidth type="number"
                               InputProps={{
                                   endAdornment: <InputAdornment position="start">$/MW-Day</InputAdornment>,
                                   inputComponent: TwoDigitCurrency,
                                   inputProps: {isEdit: true}
                               }}/>
                </Grid>
                <Grid item xs={6} sm={1}/>
                <Grid item xs={6} sm={3}>
                    {renderAddIcon(totalCount, index)}
                    <IconButton onClick={() => removeIconClick(index)}>
                        <RemoveIcon/>
                    </IconButton>
                </Grid>
            </Grid>
        )
    }

    const onSave = async () => {
        for (let resourceClearingPrice of auctionResourceClearingPrice.resourceClearingPrices) {
            resourceClearingPrice.systemMarginalPrice = auctionResourceClearingPrice.systemMarginalPrice;
        }
        await trackPromise(axios.post("/capacity/deliveryYear/" + auctionResourceClearingPrice.deliveryYear.replace("/", "-") +
            "/auction/" + auctionResourceClearingPrice.auction + "/resourceClearingPrice", JSON.stringify(auctionResourceClearingPrice.resourceClearingPrices)).then(response => {
            dispatch(onSuccess("Saved resource clearing prices for delivery year " + auctionResourceClearingPrice.deliveryYear + " and auction " + auctionResourceClearingPrice.auction));
            history.push("/capacity/resourceClearingPrice/view");
        }).catch(error => {
            dispatch(onError(error));
        }));
    }

    return (
        <main className={classes.layout}>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={1}/>
                <Grid item xs={6} sm={3}>
                    {deliveryYearAuctions && renderDeliveryYearSelectBox()}
                </Grid>
                <Grid item xs={6} sm={1}/>
                <Grid item xs={6} sm={3}>
                    {renderAuctionSelectBox()}
                </Grid>
                <Grid item xs={6} sm={1}/>
                <Grid item xs={6} sm={3}>
                    <TextField label="System Marginal Price" name="systemMarginalPrice" value={cleanStringInput(auctionResourceClearingPrice.systemMarginalPrice)}
                               onChange={onSystemMarginalPriceChange} fullWidth type="number"
                               InputProps={{
                                   endAdornment: <InputAdornment position="start">$/MW-Day</InputAdornment>,
                                   inputComponent: TwoDigitCurrency,
                                   inputProps: {isEdit: true}
                               }}/>
                </Grid>
            </Grid>
            {renderResourceClearingPrices()}
            <Grid container spacing={2}>
                <Grid item xs={6} sm={4}/>
                <Grid item xs={6} sm={4}>
                    <Button onClick={onSave} fullWidth>Save</Button>
                </Grid>
                <Grid item xs={6} sm={4}/>
            </Grid>
        </main>
    )

}

export default CreateResourceClearingPrices;